/**
 * Display a config group
 * 
 * @author: Vanessa Richie Alia-Trapero <vanessa@dividia.net>
 */

import ConfigField from './ConfigField'

const ConfigGroup = (props) => {
  const {deviceId, name, fields, basicFields, duplicate, showAdvanced, cameraPage, handleInputChange, handleGroupDuplicate, handleGroupDelete, handleNewProperty} = props
  
  return (
    <div style={{...styles.formGroup, backgroundColor: duplicate ? 'rgb(56, 172, 236)' : 'transparent', color: duplicate ? 'black' : 'white'}}>
      <div style={styles.formGroupHeader}>
        <label>{name}</label>
        {(name.startsWith('camera') && showAdvanced) &&
          <div style={styles.formGroupButtons}>
            <button style={styles.formGroupButton} onClick={() => handleGroupDuplicate(name)}>Duplicate</button>
            <button style={styles.formGroupButton} onClick={() => handleGroupDelete(name)}>Delete</button>
          </div>
        }
      </div>
      
      <div style={styles.formGroupFields}>
        {Object.entries(fields).map(([label, value]) => {
          const displayField = (showAdvanced || basicFields.includes(label) || basicFields[0] === '*')
          return displayField &&
            <ConfigField deviceId={deviceId} key={name + '-' + label} group={name} name={label} value={value} showAdvanced={showAdvanced} handleInputChange={handleInputChange} />
        })}
      </div>
      
      <div style={styles.formGroupFooter}>
        {(showAdvanced || cameraPage) && <button style={styles.formGroupButton} onClick={() => handleNewProperty(true, name)}>+</button>}
      </div>
    </div>
  )
}

export default ConfigGroup

const styles = {
  formGroup: {
    padding: '1vmin 0',
    fontSize: '1.6vmin',
  },
  formGroupHeader: {
    display: 'flex',
    justifyContent: 'start',
    gap: '1vmin',
    alignItems: 'baseline',
  },
  formGroupButtons: {
    display: 'flex',
    gap: '1vmin',
  },
  formGroupButton: {
    cursor: 'pointer',
    fontSize: '1.4vmin',
  },
  formGroupFields: {
    padding: '1vmin 1vmin 0 2vmin',
  },
  formGroupFooter: {
    paddingLeft: '2vmin',
  },
}